'use client';
import type { ReactElement } from 'react';
import { motion } from 'framer-motion';
import { ButtonPreset } from '@/constants/componentPresets';
import { ColorType } from '@/theme/colors';
import { FontWeight } from '@/theme/typography';
import { Cbutton } from '../Cbutton';
import { Ctext } from '../Ctext';
import { EQUIP_PILL_CONTAINER_STYLE, HeroCarouselControlsAnimationEvent, type HeroCarouselControlsAnimationEventHandler, HeroCarouselControlsViewport, } from './Cherocarouselcontrols.constants';
import { notifyHeroCarouselControlsAnimationEvent, resolveHeroCarouselControlsOpacityAnimation, resolveHeroCarouselControlsTransition, } from './Cherocarouselcontrols.motion';
import { DEPLOY_INSPECT_SHELL_STYLE } from './deployInspectControlStyles';
interface DeployInspectControlProps {
    controlsViewport: HeroCarouselControlsViewport;
    shouldShowControls: boolean;
    controlsEntranceDelay: number;
    onDeployTeam?: () => void;
    onInspectTeam?: () => void;
    onAnimationEvent?: HeroCarouselControlsAnimationEventHandler;
}
const DEPLOY_TEXT_SIZE_BY_VIEWPORT: Record<HeroCarouselControlsViewport, number> = {
    [HeroCarouselControlsViewport.Mobile]: 19.2,
    [HeroCarouselControlsViewport.Desktop]: 24,
};
const DEPLOY_PADDING_BY_VIEWPORT: Record<HeroCarouselControlsViewport, string> = {
    [HeroCarouselControlsViewport.Mobile]: '11px 30px',
    [HeroCarouselControlsViewport.Desktop]: '10px 62px',
};
const DEPLOY_BUTTON_CONTAINER_STYLE = {
    boxShadow: 'rgb(256 256 256 / 32%) -1px 2px 4px inset, rgb(0 0 0 / 22%) 4px 1px 5px ',
};
const DEPLOY_BUTTON_TEXT_STYLE = {
    textShadow: 'rgb(0 0 0 / 41%) 1px 2px 4px',
};
export function DeployInspectControl({ controlsViewport, shouldShowControls, controlsEntranceDelay, onDeployTeam, onInspectTeam, onAnimationEvent, }: DeployInspectControlProps): ReactElement {
    return <motion.div initial={{ opacity: 0 }} animate={resolveHeroCarouselControlsOpacityAnimation({ shouldShowControls })} onAnimationStart={() => {
            notifyHeroCarouselControlsAnimationEvent({
                onAnimationEvent,
                eventName: HeroCarouselControlsAnimationEvent.DeployInspectStart,
            });
        }} onAnimationComplete={() => {
            notifyHeroCarouselControlsAnimationEvent({
                onAnimationEvent,
                eventName: HeroCarouselControlsAnimationEvent.DeployInspectComplete,
            });
        }} transition={resolveHeroCarouselControlsTransition({
            shouldShowControls,
            controlsEntranceDelay,
        })} style={{ display: 'flex' }}>
	            <div data-cabal-control="deploy-inspect-row" style={{
            ...EQUIP_PILL_CONTAINER_STYLE,
            ...DEPLOY_INSPECT_SHELL_STYLE,
        }}>
	                <Cbutton preset={ButtonPreset.Primary} onClick={onDeployTeam} containerStyle={DEPLOY_BUTTON_CONTAINER_STYLE} padding={DEPLOY_PADDING_BY_VIEWPORT[controlsViewport]}>
	                    <Ctext size={DEPLOY_TEXT_SIZE_BY_VIEWPORT[controlsViewport]} color={ColorType.White} weight={FontWeight.SemiBold} opacity={1} style={DEPLOY_BUTTON_TEXT_STYLE}>
                        Deploy
                    </Ctext>
                </Cbutton>
	                <Cbutton preset={ButtonPreset.Ghost} onClick={onInspectTeam} padding="10px 30px 10px 20px">
	                    <Ctext size={DEPLOY_TEXT_SIZE_BY_VIEWPORT[controlsViewport]} color={ColorType.White} weight={FontWeight.SemiBold} opacity={1}>
                        Inspect
                    </Ctext>
                </Cbutton>
            </div>
        </motion.div>
        ;
}
